import queryString from 'query-string';
var STORAGE_KEY_IN_TEAMS = 'hostContext_inTeams';
var STORAGE_KEY_IN_EXTENSION = 'hostContext_inExtension';
var STORAGE_KEY_IN_OFFICE = 'hostContext_inOffice';
function readFromUrl(param) {
    var readFromSearchParams = function readFromSearchParams() {
        try {
            var searchParams = new URLSearchParams(window.location.search);
            if (searchParams.get(param) === 'true') return true;
            var hashQuery = window.location.hash.split('?')[1];
            if (!hashQuery) return false;
            var hashParams = new URLSearchParams(hashQuery);
            return hashParams.get(param) === 'true';
        } catch (unused) {
            return false;
        }
    };
    var readFromHref = function readFromHref() {
        return window.location.href.includes("".concat(param, "=true"));
    };
    // Old version of query string detection
    // Legacy check
    var readFromQueryString = function readFromQueryString() {
        var _queryString_parse;
        return ((_queryString_parse = queryString.parse(location.search)) === null || _queryString_parse === void 0 ? void 0 : _queryString_parse[param]) === 'true';
    };
    return readFromSearchParams() || readFromHref() || readFromQueryString();
}
function readFromLocalStorage(key) {
    try {
        var timestamp = localStorage.getItem(key);
        if (!timestamp) return false;
        var parsedTimestamp = Number(timestamp);
        if (Number.isNaN(parsedTimestamp)) {
            // Corrupted value
            localStorage.removeItem(key);
            return false;
        }
        // Check if older than one day
        var isExpired = Date.now() - parsedTimestamp > 24 * 60 * 60 * 1000;
        if (isExpired) {
            // Clear if expired
            localStorage.removeItem(key);
        }
        return !isExpired;
    } catch (unused) {
        // Possible corrupted value
        try {
            localStorage.removeItem(key);
        } catch (e) {
        // NOOP
        }
        return false;
    }
}
function writeToLocalStorage(key, value) {
    try {
        if (value) {
            localStorage.setItem(key, Date.now().toString());
        } else {
            localStorage.removeItem(key);
        }
    } catch (unused) {
    // NOOP
    }
}
export function persistHostContext() {
    if (readFromUrl('inTeams')) {
        writeToLocalStorage(STORAGE_KEY_IN_TEAMS, true);
    } else if (readFromUrl('inOffice')) {
        writeToLocalStorage(STORAGE_KEY_IN_OFFICE, true);
    }
}
export function checkHostContextInTeams() {
    return readFromUrl('inTeams') || readFromLocalStorage(STORAGE_KEY_IN_TEAMS);
}
export function checkHostContextInExtension() {
    return readFromUrl('inExtension');
}
// Dev-only: render the meeting extension in a plain browser, where app.getContext() never resolves.
export function checkSimulatedExtension() {
    return process.env.NODE_ENV !== 'production' && readFromUrl('simulateExtension');
}
export function checkSimulatedDarkTheme() {
    return checkSimulatedExtension() && readFromUrl('simulateDark');
}
export function checkHostContextInOffice() {
    return readFromUrl('inOffice') || readFromLocalStorage(STORAGE_KEY_IN_OFFICE);
}
export function clearHostContext() {
    try {
        localStorage.removeItem(STORAGE_KEY_IN_TEAMS);
        localStorage.removeItem(STORAGE_KEY_IN_EXTENSION);
        localStorage.removeItem(STORAGE_KEY_IN_OFFICE);
    } catch (unused) {
    // NOOP
    }
}
